import { createFileRoute } from '@tanstack/react-router';

import { EstimatePage } from '../../../../features/estimates/ui/estimate-page.tsx';
import { requirePermissionRoute } from '../../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/sales/deals/$id_/estimate')({
  beforeLoad: requirePermissionRoute('sales.use'),
  component: EstimateRoute,
});

/** Смета сделки на всю страницу: `/sales/deals/<id>/estimate`. */
function EstimateRoute() {
  const { id } = Route.useParams();
  return <EstimatePage dealId={id} />;
}
